import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, name, ...props }) => {
  if (IconComponent) {
    return <IconComponent {...props} />;
  }
  
  if (name) {
    const DynamicIcon = FiIcons[`Fi${name}`];
    if (DynamicIcon) return <DynamicIcon {...props} />;
  }

  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;